<ng-container *transloco="let t">
  @if (error(); as message) {
    <alert [type]="'danger'" class="d-block">{{ t(message) }}</alert>
  }

  <ng-container *transloco="let accountT; scope: 'account'">
    <div class="content-holder">
      <div class="header align-items-center">
        <p class="title">{{ accountT('account.subscriptions.news_service') }}</p>
        <div class="subtitle">{{ accountT('account.subscriptions.news_service_intro') }}</div>
      </div>

      <div class="row body">
        <div class="col-12 mt-4">
          @if (newsService() !== undefined) {
            @let choice = newsChoice();

            <label class="filters-title d-block" for="newsCadence">{{ accountT('account.subscriptions.frequency') }}</label>
            <select class="form-select form-control w-auto" id="newsCadence" name="newsCadence"
              [ngModel]="choice.cadence" [disabled]="isAnythingLoading()" (ngModelChange)="chooseCadence($event)">
              @for (cadence of cadences; track cadence) {
                <option [value]="cadence">{{ accountT('account.subscriptions.cadence.' + cadence) }}</option>
              }
            </select>

            <fieldset class="mt-3" [disabled]="isAnythingLoading()">
              <legend class="filters-title fs-6">{{ accountT('account.subscriptions.coverage') }}</legend>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="newsCoverage" id="newsBigOnly"
                  [checked]="choice.bigNewsOnly" (change)="chooseNews({ bigNewsOnly: true })">
                <label class="form-check-label" for="newsBigOnly">{{ accountT('account.subscriptions.big_news_only') }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="newsCoverage" id="newsAll"
                  [checked]="!choice.bigNewsOnly" (change)="chooseNews({ bigNewsOnly: false })">
                <label class="form-check-label" for="newsAll">{{ accountT('account.subscriptions.all_news') }}</label>
              </div>
            </fieldset>

            <div class="mt-3">
              @if (newsService()) {
                <button type="button" class="btn btn-outline-danger btn-sm" [disabled]="isAnythingLoading()"
                  (click)="leaveNewsService()">{{ accountT('account.subscriptions.unsubscribe') }}</button>
              } @else {
                <button type="button" class="btn btn-primary" [disabled]="isAnythingLoading()"
                  (click)="takeNewsService()">{{ accountT('account.subscriptions.subscribe') }}</button>
              }
            </div>
          }

          <p class="mt-3 mb-0">
            <a [routerLink]="['/news']">{{ t('news.all_news') }} <i class="fa-solid fa-angle-right ml-1"></i></a>
          </p>
        </div>
      </div>
    </div>

    <div class="content-holder">
      <div class="header align-items-center">
        <p class="title">{{ accountT('account.subscriptions.yours') }}</p>
        <div class="subtitle">{{ accountT('account.subscriptions.yours_intro') }}</div>
      </div>

      <div class="row body">
        <div class="col-12 mt-4">
          @if (rows().length) {
            <div class="list-group mb-3">
              @for (row of rows(); track row.subscription.id) {
                @let subscription = row.subscription;
                <div class="list-group-item d-flex flex-wrap align-items-center gap-3">
                  <div class="flex-grow-1">
                    <span class="d-block font-weight-bold">{{ row.name }}</span>
                    <span class="badge badge-pill badge-info">{{ t(kindLabels[row.kind]) }}</span>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" role="switch" [id]="'inApp_' + subscription.id"
                      [checked]="subscription.inApp" [disabled]="isAnythingLoading()"
                      (change)="toggle(subscription, 'inApp', $any($event.target).checked)">
                    <label class="form-check-label" [for]="'inApp_' + subscription.id">{{ accountT('account.subscriptions.in_app') }}</label>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" role="switch" [id]="'email_' + subscription.id"
                      [checked]="subscription.email" [disabled]="isAnythingLoading()"
                      (change)="toggle(subscription, 'email', $any($event.target).checked)">
                    <label class="form-check-label" [for]="'email_' + subscription.id">{{ t('common.email') }}</label>
                  </div>
                  <button type="button" class="btn btn-outline-danger btn-sm" [disabled]="isAnythingLoading()"
                    (click)="unsubscribe(subscription)">{{ accountT('account.subscriptions.unsubscribe') }}</button>
                </div>
              }
            </div>
          } @else if (!isAnythingLoading()) {
            <alert [type]="'info'" class="d-block">{{ accountT('account.subscriptions.nothing_subscribed') }}</alert>
          }

          @if (isAnythingLoading()) {
            <div class="d-flex justify-content-center py-3">
              <multisite-loader-globe-animation-detail [width]="64" [height]="64"></multisite-loader-globe-animation-detail>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="content-holder">
      <div class="header align-items-center">
        <p class="title">{{ accountT('account.subscriptions.more') }}</p>
      </div>

      <div class="row body">
        <div class="col-12 mt-4">
          <label class="filters-title d-block" for="newApplication">{{ t('common.application') }}</label>
          <div class="input-group">
            <select class="form-select form-control" id="newApplication" name="newApplication" [(ngModel)]="newApplication">
              <option value="">{{ t('common.select') }}</option>
              @for (topic of availableApplications(); track topic.id) {
                <option [value]="topic.slug">{{ topic.name }}</option>
              }
            </select>
            <button type="button" class="btn btn-primary" [disabled]="!newApplication || isAnythingLoading()"
              (click)="subscribe({ type: 'topics', id: newApplication })">{{ accountT('account.subscriptions.subscribe') }}</button>
          </div>

          <label class="filters-title d-block mt-3" for="newCulture">{{ t('common.culture') }}</label>
          <div class="input-group">
            <select class="form-select form-control" id="newCulture" name="newCulture" [(ngModel)]="newCulture">
              <option value="">{{ t('common.select') }}</option>
              @for (culture of availableCultures(); track culture.id) {
                <option [value]="culture.slug">{{ culture.name }}</option>
              }
            </select>
            <button type="button" class="btn btn-primary" [disabled]="!newCulture || isAnythingLoading()"
              (click)="subscribe({ type: 'cultures', id: newCulture })">{{ accountT('account.subscriptions.subscribe') }}</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
